import { Button, Divider, Modal } from "antd";
import React from "react";

import TextInfo from "../../../../../components/common/TextInfo/TextInfo";

const AddRefundDialog = ({
  visible,
  handleCancel,
  handleSave,
  actionButtonText,
  title,
  onInputChange,
  onSelectChange,
  errors,
  data,
  bankOptions,
  onImageChange,
  handleUploadImage,
  transferProofImg,
  approvalProofImg,
  dataDetail
}) => {
  const handleChange =
    (type, field = "") =>
    (event) => {
      if (type === "number") {
        onInputChange(field, event.value);
      } else if (type === "input") {
        const { name, value } = event.target;
        onInputChange(name, value);
      }
    };

  return (
    <Modal
      className="modal-form"
      title={title}
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        
        <Button
          key="submit"
          type="primary"
          onClick={handleSave}
          className="btn-modal"
        >
          {actionButtonText}
        </Button>,
      ]}
    >
      <div className="detail-header">
        <TextInfo
          title="No. Surat Bukti Gadai"
          value={dataDetail?.pawnNumber}
        />
        <TextInfo title="No. Kwitansi" value={dataDetail?.receiptNumber} />
        <TextInfo title="Nama Nasabah" value={dataDetail?.customerName} />
        <TextInfo title="NIK" value={dataDetail?.nik} />
        <TextInfo title="No. Telpepon" value={dataDetail?.phone} />
        <TextInfo title="Sisa Uang Lelang" value={dataDetail?.remainingMoney} />
      </div>
      <Divider dashed className="detail-divider" />
      <div className="modal-form-content" style={{ gap: "0px" }}>
        <TextInfo
          title="Bank"
          value={data.bankName}
          type={"select"}
          id={"bankName"}
          handleChange={onSelectChange}
          error={errors?.bankName}
          placeholder={"Pilih Bank"}
          isSearchable
          selectOptions={bankOptions}
          isForm
        />
        <TextInfo
          title="No. Rekening"
          value={data.accountNumber}
          type={"input"}
          id={"accountNumber"}
          handleChange={handleChange("input")}
          error={errors?.accountNumber}
          placeholder={"Masukkan Nomor Rekening"}
          isForm
        />
        <TextInfo
          title="Nama Rekening"
          value={data.accountName}
          type={"input"}
          id={"accountName"}
          handleChange={handleChange("input")}
          error={errors?.accountName}
          placeholder={"Masukkan Nama Rekening"}
          isForm
        />
        <TextInfo
          title="Bukti Transfer"
          type={"upload"}
          id={"transferProof"}
          helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
          handleImageChange={onImageChange("transferProof")}
          customRequest={handleUploadImage("transferProof")}
          fileList={transferProofImg}
          error={errors?.transferProof}
          isForm
        />
        <TextInfo
          title="Bukti Persetujuan"
          type={"upload"}
          id={"transferProof"}
          helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
          handleImageChange={onImageChange("approvalProof")}
          customRequest={handleUploadImage("approvalProof")}
          fileList={approvalProofImg}
          error={errors?.approvalProof}
          isForm
        />
      </div>
    </Modal>
  );
};

export default AddRefundDialog;
